import React from 'react';

const WireBindingOptions = ({ // Consider renaming to FinishingProcessMaterialOptions for reusability
  finishingMaterials,
  finishingOptions,
  handleOptionChange,
  handleCheckboxChange
}) => {
  const processId = 'wirebind'; // Hardcode the process ID for wire binding
  const materialsForProcess = finishingMaterials?.[processId] || []; // Added safe navigation for finishingMaterials


  // Filter materials by type for wire-binding
  const wireOptions = materialsForProcess.filter(m => m.type === 'wire'); // Corrected back to 'wire' to match DB
  const acetateOptions = materialsForProcess.filter(m => m.type === 'acetate');
  const cardBackOptions = materialsForProcess.filter(m => m.type === 'card_back');

  // Check if there are any options to display
  const hasOptionsToShow = wireOptions.length > 0 || acetateOptions.length > 0 || cardBackOptions.length > 0;

  if (!hasOptionsToShow) {
    return <p className="text-xs text-gray-500">No specific material options found for wire binding.</p>;
  }

  return (
    <div className="mt-4 pt-4 border-t">
      <h4 className="font-semibold text-sm mb-3">Wire Binding Options:</h4>
      <> {/* Using a React Fragment to group elements */}
        {/* --- Binding Edge Selection --- */}
        <div className="mb-3">
          <label className="block text-xs font-medium mb-1">Binding Edge:</label>
          <select
            value={finishingOptions[processId]?.bindingEdge || 'left'}
            onChange={(e) => handleOptionChange(processId, 'bindingEdge', e.target.value)}
            className="w-full p-1 border rounded text-sm"
          >
            <option value="left">Left Edge</option>
            <option value="top">Top Edge</option>
            <option value="right">Right Edge</option>
            <option value="bottom">Bottom Edge</option>
          </select>
          <p className="text-xs text-gray-500 mt-1">
            Which edge should the wire binding be applied to?
          </p>
        </div>

        {/* --- Wire Selection --- */}
        {wireOptions.length > 0 && (
          <div className="mb-3">
            <label className="block text-xs font-medium mb-1">Wire Type/Color:</label>
            <select
              value={finishingOptions[processId]?.wire || ''}
              onChange={(e) => handleOptionChange(processId, 'wire', e.target.value)}
              className="w-full p-1 border rounded text-sm"
            >
              <option value="">Select Wire...</option>
              {wireOptions.map(wire => (
                <option key={wire.material_id} value={wire.material_id}>
                  {wire.name} {wire.cost > 0 ? `(+£${wire.cost.toFixed(2)})` : ''}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* --- Acetate Selection (Dropdowns for Front/Back) --- */}
        {acetateOptions.length > 0 && (
          <div className="mb-3 space-y-1">
            <label className="block text-xs font-medium mb-1">Acetates:</label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
              <div>
                <label className="block text-xs font-medium mb-1">Front:</label>
                <select
                  value={finishingOptions[processId]?.acetateFront || ''}
                  onChange={(e) => handleOptionChange(processId, 'acetateFront', e.target.value)}
                  className="w-full p-1 border rounded text-sm"
                >
                  <option value="">Select Front Acetate...</option>
                  {acetateOptions
                    .filter(acetate => acetate.location === 'front' || acetate.location === 'both')
                    .map(acetate => (
                      <option key={acetate.material_id} value={acetate.material_id}>
                        {acetate.name} {acetate.cost > 0 ? `(+£${acetate.cost.toFixed(2)})` : ''}
                      </option>
                    ))}
                </select>
              </div>

              <div>
                <label className="block text-xs font-medium mb-1">Back:</label>
                <select
                  value={finishingOptions[processId]?.acetateBack || ''}
                  onChange={(e) => handleOptionChange(processId, 'acetateBack', e.target.value)}
                  className="w-full p-1 border rounded text-sm"
                >
                  <option value="">Select Back Acetate...</option>
                  {acetateOptions
                    .filter(acetate => acetate.location === 'back' || acetate.location === 'both')
                    .map(acetate => (
                      <option key={acetate.material_id} value={acetate.material_id}>
                        {acetate.name} {acetate.cost > 0 ? `(+£${acetate.cost.toFixed(2)})` : ''}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          </div>
        )}

        {/* --- Card Back Selection --- */}
        {cardBackOptions.length > 0 && (
          <div className="mb-3 space-y-1">
            <label className="block text-xs font-medium mb-1">Card Back:</label>
            {cardBackOptions.map(card => {
              const optionKey = 'cardBack'; // Assuming only one type of card back option
              return (
                <div key={card.material_id} className="flex items-center">
                  <input
                    type="checkbox"
                    id={`mat-${processId}-${card.material_id}`}
                    checked={finishingOptions[processId]?.[optionKey] === card.material_id}
                    onChange={(e) => handleCheckboxChange(processId, optionKey, card, e.target.checked)}
                    className="mr-2 h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  />
                  <label htmlFor={`mat-${processId}-${card.material_id}`} className="text-sm">
                    {card.name} {card.cost > 0 ? `(+£${card.cost.toFixed(2)})` : ''}
                  </label>
                </div>
              );
            })}
          </div>
        )}
      </> {/* Closing React Fragment */}
    </div>
  );
};

export default WireBindingOptions;